import React from 'react';
import { AppBar, Box, Tab, Tabs, Typography } from '@mui/material';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router';

import { getSpinnersToDisplay, SpinnerMessage } from '@paragon/task-spinner';

import { useAppSelector } from './hooks';
import { Backlog } from './pages/backlog/Backlog';
import { BatchesAndBundles } from './pages/batches-and-bundles/BatchesAndBundles';
import { History } from './pages/history/History';
import { LineSchedule } from './pages/line-schedule/LineSchedule';
import { Schedule } from './pages/schedule/Schedule';
import { Truckloads } from './pages/truckloads/Truckloads';

export const BATCHES_AND_BUNDLES_URL_SLUG = '/batches-and-bundles';
const BACKLOG_URL_SLUG = '/backlog';
const SCHEDULE_URL_SLUG = '/schedule';
const LINE_SCHEDULE_URL_SLUG = '/line-schedule';
const TRUCKLOADS_URL_SLUG = '/truckloads';
const HISTORY_URL_SLUG = '/history';
const METRICS_URL_SLUG = '/metrics';

const allSlugs = [
  BATCHES_AND_BUNDLES_URL_SLUG,
  BACKLOG_URL_SLUG,
  SCHEDULE_URL_SLUG,
  LINE_SCHEDULE_URL_SLUG,
  TRUCKLOADS_URL_SLUG,
  HISTORY_URL_SLUG,
  METRICS_URL_SLUG,
];

export function Content() {
  const spinnerMessages = useAppSelector(getSpinnersToDisplay);

  const location = useLocation();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        height: '95%',
        bgcolor: 'background.default',
        padding: 3,
        minWidth: 0, // So the Typography noWrap works
      }}
    >
      {Array.from(spinnerMessages).map((text) => (
        <SpinnerMessage text={text} key={text} />
      ))}

      {allSlugs.includes(location.pathname) && (
        <AppBar enableColorOnDark position="static">
          <Tabs indicatorColor="secondary" textColor="inherit" value={location.pathname} variant="fullWidth">
            <Tab
              label="Batches & Bundles"
              component={Link}
              to={BATCHES_AND_BUNDLES_URL_SLUG}
              value={BATCHES_AND_BUNDLES_URL_SLUG}
            />
            <Tab label="Backlog" component={Link} to={BACKLOG_URL_SLUG} value={BACKLOG_URL_SLUG} />
            <Tab label="Schedule" component={Link} to={SCHEDULE_URL_SLUG} value={SCHEDULE_URL_SLUG} />
            <Tab label="Line Schedule" component={Link} to={LINE_SCHEDULE_URL_SLUG} value={LINE_SCHEDULE_URL_SLUG} />
            <Tab label="Truckloads" component={Link} to={TRUCKLOADS_URL_SLUG} value={TRUCKLOADS_URL_SLUG} />
            <Tab label="History" component={Link} to={HISTORY_URL_SLUG} value={HISTORY_URL_SLUG} />
            <Tab label="Metrics" component={Link} to={METRICS_URL_SLUG} value={METRICS_URL_SLUG} />
          </Tabs>
        </AppBar>
      )}

      <Routes>
        <Route path={BATCHES_AND_BUNDLES_URL_SLUG} element={<BatchesAndBundles />} />
        <Route path={BACKLOG_URL_SLUG} element={<Backlog />} />
        <Route path={SCHEDULE_URL_SLUG} element={<Schedule />} />
        <Route path={LINE_SCHEDULE_URL_SLUG} element={<LineSchedule />} />
        <Route path={TRUCKLOADS_URL_SLUG} element={<Truckloads />} />
        <Route path={HISTORY_URL_SLUG} element={<History />} />
        <Route path={METRICS_URL_SLUG} element={<Typography>Coming soon</Typography>} />
        <Route path="*" element={<Navigate to={SCHEDULE_URL_SLUG} replace />} />
      </Routes>
    </Box>
  );
}
